import PropTypes from 'prop-types';
import React from 'react';
import MenuItemAction from './MenuItemAction';

class AnchorMenuItemAction extends React.Component {
    render() {
        return (
            <a
                className="menu__item__action__link"
                href={this.props.url}
                {...this.props.anchorProps}
            >
                {this.props.children}
            </a>
        );
    }
}

AnchorMenuItemAction.propTypes = {
    url: PropTypes.string.isRequired,
    anchorProps: PropTypes.object,
};

AnchorMenuItemAction.defaultProps = {
    anchorProps: {},
};

export default MenuItemAction(AnchorMenuItemAction);



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/AnchorMenuItemAction.jsx